export const baseURL = "https://teenpatti.ajobfun.cloud/";
export const adminBaseURL = "https://admin.ajobfun.cloud/";
export const key = "BS67Rfb0Tf";
